import { ReactElement } from 'react';
import PaymentArrangements from '@components/FVSPage/PaymentArrangements';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep11(): ReactElement {
  return (
    <>
      <PaymentArrangements displayObject={fvsInfoDisplayObject} currentStepNo="step11" />
    </>
  );
}

export default FVSStep11;
